import script from "./StockDocumentTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./StockDocumentTypes.vue?vue&type=script&setup=true&lang=js"

import "./StockDocumentTypes.vue?vue&type=style&index=0&id=720e246c&lang=css"

const __exports__ = script;

export default __exports__